export default "__VITE_ASSET__DSeH5CM7__"